export default "__VITE_ASSET__5b2e04d1__"